/**
 * Horizontal crop (Cut L/R) for a layer, mirroring the player's CutWrapper.
 * cutLeft/cutRight are percent (0-100) of the layer's own width; the visible middle portion is kept.
 * Applied as clip-path (not transform) so LiveKit ParticipantTile's IntersectionObserver/attach keeps working.
 */
export function getLayerCutClipPath(cutLeft?: number | null, cutRight?: number | null): string | undefined {
  const left = cutLeft ?? 0;
  const right = cutRight ?? 0;
  const total = left + right;
  if (total <= 0 || total >= 100) {
    return undefined;
  }
  return `inset(0 ${right}% 0 ${left}%)`;
}
